import { usePageAiMeta } from '@plato/app-shared/hooks/use-page-ai-meta';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useCustomerListColumns } from '../components/customer-list-table.tsx';

export function useCustomerListAiMeta(): ReturnType<typeof usePageAiMeta> {
    const { t } = useTranslation();
    const columns = useCustomerListColumns({});
    const registryColumns = useMemo(
        () => columns.map(({ id, header, meta }) => ({ accessorKey: id, header, meta })),
        [columns],
    );

    return usePageAiMeta(
        {
            path: '/customers',
            title: t('page_title__customers', { ns: 'common' }),
            description:
                'The place to compare customers side by side and find the ones to act on. Sort or ' +
                'filter by the listed columns to see who is growing, declining or at risk by {{metric}} ' +
                'against last year, then open one for its detail page.',
        },
        registryColumns,
    );
}
